import { useNavigate } from "react-router-dom";
import { Recycle } from "lucide-react";

import { useEffect, useState } from "react";
import apiClient from "../../../../shared/API/apiClient";
import { useLocation } from "react-router-dom";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

export default function RecyclingRateDetails() {
  const navigate = useNavigate();

  const location = useLocation();

  const saved = JSON.parse(sessionStorage.getItem("water_filters"));

  const reporting_year_id =
    location.state?.reporting_year_id || saved?.reporting_year_id;

  const legal_entity_id =
    location.state?.legal_entity_id || saved?.legal_entity_id;

  // state
  const [summary, setSummary] = useState({});
  const [formula, setFormula] = useState({});
  const [trend, setTrend] = useState([]);

  //   const trend = [
  //     { month: "Apr", value: 28 },
  //     { month: "May", value: 31 },
  //     { month: "Jun", value: 33 },
  //     { month: "Jul", value: 34 },
  //     { month: "Aug", value: 36 },
  //     { month: "Sep", value: 35 },
  //     { month: "Oct", value: 37 },
  //     { month: "Nov", value: 37.5 },
  //   ];

  // API call

  useEffect(() => {
    if (!reporting_year_id || !legal_entity_id) return;

    const fetchRecyclingRate = async () => {
      try {
        const res = await apiClient.get("/api/water-summary/recycling-rate", {
          params: {
            reporting_year_id,
            legal_entity_id,
          },
        });

        if (res.data.code === 200) {
          const data = res.data;

          setSummary(data.summary || {});
          setFormula(data.formula || {});
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchRecyclingRate();
  }, [reporting_year_id, legal_entity_id]);

  const recycled = summary?.recycled || 0;
  const total = summary?.consumption || 0;
  const rate = summary?.rate || 0;

  return (
    <div className="dash-page">
      {/* Header */}
      <div className="ws-title">Recycling Rate Calculation</div>
      <div className="ws-subtitle">
        Calculated KPI showing recycled water as a share of total consumption
      </div>

      {/* KPI */}
      <div className="ws-top-metric">
        <span className="ws-top-value">% {rate}</span>
        <span className="ws-top-unit">recycling rate</span>
      </div>

      {/* Calculation Card */}
      <div className="rr-card">
        <div className="rr-card-title">Calculation</div>

        <div className="rr-calc-grid">
          <div className="rr-box">
            <div className="rr-box-label">WATER RECYCLED</div>
            <div className="rr-box-value">{recycled}</div>
            <div className="rr-box-unit">m³</div>
          </div>

          <div className="rr-box">
            <div className="rr-box-label">÷ TOTAL CONSUMPTION</div>
            <div className="rr-box-value">{total}</div>
            <div className="rr-box-unit">m³</div>
          </div>

          <div className="rr-box">
            <div className="rr-box-label">= RECYCLING RATE</div>
            <div className="rr-box-value">{rate}%</div>
            <div className="rr-box-unit">result</div>
          </div>
        </div>

        {/* Formula */}
        <div className="rr-formula">
          <div className="rr-formula-box">
            <div className="rr-formula-title">Formula</div>
            <span className="formula-exp"> {formula?.expression}</span>
            <br></br>
            <span className="formula-cal"> {formula?.calculation}</span>
          </div>
        </div>
      </div>

      {/* Trend */}
      {/* <div className="rr-card">
        <div className="rr-card-title">Monthly Recycling Rate Trend</div>

        <div style={{ width: "100%", height: 260 }}>
          <ResponsiveContainer>
            <LineChart className="chartSize" data={trend}>
              <CartesianGrid stroke="#e5e7eb" strokeDasharray="4 4" />

              <XAxis dataKey="month" />

              <YAxis domain={[0, 40]} tickCount={5} />

              <Tooltip />

              <Line
                type="monotone"
                dataKey="value"
                stroke="#2c3e50"
                strokeWidth={2}
                dot={{ r: 4, strokeWidth: 2 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div> */}

      {/* Back */}
      <div className="ws-back" onClick={() => navigate(-1)}>
        ← Back to Water Summary
      </div>

      {/* Footer */}
      <div className="ws-footer">
        This view shows only the calculated KPI and its trend — source and reuse
        details are available on their respective breakdown pages.
      </div>
    </div>
  );
}
